import { jsx as _jsx } from "react/jsx-runtime";
import { translate } from '../../strings/i18n';
import { Footer, FooterWrapper } from './subcomponents';
import { ChangePaymentDueDateScreen } from '../../typings';
const ChangePaymentDueDateFooter = ({ currentScreen, handleClose, handleClick, selectedDay }) => {
    const DATA_PRIMARY_TYPE = 'change due date';
    const DATA_SECONDARY_TYPE = 'back to account services';
    const DATA_CLOSE_TYPE = 'close';
    const DATA_OBJECT = 'button';
    const DATA_REASON = selectedDay ? 'selected' : 'current';
    const closeButtonPrimary = {
        primaryText: translate('button.close'),
        handlePrimaryButton: handleClose,
        dataPrimaryObject: DATA_OBJECT,
        dataPrimaryType: DATA_CLOSE_TYPE
    };
    const initialScreenButtons = {
        primaryText: translate('button.changeDueDate'),
        handlePrimaryButton: handleClick,
        dataPrimaryObject: DATA_OBJECT,
        dataPrimaryReason: DATA_REASON,
        dataPrimaryType: DATA_PRIMARY_TYPE,
        secondaryText: translate('button.backToAccountServices'),
        handleSecondaryButton: handleClose,
        secondaryButtonType: 'ghost',
        dataSecondaryObject: DATA_OBJECT,
        dataSecondaryReason: DATA_REASON,
        dataSecondaryType: DATA_SECONDARY_TYPE
    };
    const changePaymentDueDateFooter = {
        [ChangePaymentDueDateScreen.EXECUTION_ERROR_SCREEN]: closeButtonPrimary,
        [ChangePaymentDueDateScreen.INITIAL_SCREEN]: initialScreenButtons,
        [ChangePaymentDueDateScreen.SELECT_DAY_ERROR_SCREEN]: initialScreenButtons,
        [ChangePaymentDueDateScreen.SUCCESSFUL_SCREEN]: closeButtonPrimary
    };
    return (_jsx(FooterWrapper, { "data-testid": "change-payment-due-date-footer", children: _jsx(Footer, { ...changePaymentDueDateFooter[currentScreen] }) }));
};
export default ChangePaymentDueDateFooter;
